import Validatable from '../../../mixins/Validatable.js';
import ContentLoader from '../../../mixins/ContentLoader.js';
import LotteryForm from '../../../components/lottery/LotteryForm.vue';
import { generalParams } from '../../../../api/lottery.api';
import { ValidationObserver } from 'vee-validate';

export default {
	components: {
		LotteryForm,
		ValidationObserver
	},
	mixins: [Validatable, ContentLoader],
	data() {
		return {
			lottery: {
				name: '',
				logo: null,
				timezone: ''
			},
			params: {
				timezones: []
			}
		};
	},
	mounted() {
		generalParams().then(response => {
			this.params.timezones = response.data.timezones;
		});
	}
};
